import { observer } from 'mobx-react';
import { useCallback } from 'react';
import MealSize from '../../components/MealSize/MealSize';
import mealsStore from '../../store/mealsStore';
import integrationsStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import { scrollToElement } from 'src/utils/helpers';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import './style.scss';

const MealSizes: React.FC = observer((): JSX.Element => {
  const addSize = useCallback(() => {
    const newSizeId: number | undefined = mealsStore.addSize();
    if (newSizeId) scrollToElement({ id: `${newSizeId}-meal-size` });
  }, []);

  return (
    <ul className="meal-sizes">
      {mealsStore.meal?.sizes.length ? <div className="meal-sizes__span" /> : null}
      {mealsStore.meal?.sizes.map((size) => (
        <MealSize key={size.id} size={size} />
      ))}
      <IntegrationManager
        setting={integrationsStore.posRestrictions?.comboMealSizeCreate}
        wrapperClassName="meal-sizes__btn-add-wrapper pr-4"
        withTooltip
      >
        <button onClick={addSize} className="meal-sizes__btn-add letter-spacing-12">
          {localeStore.t('add_size')}
        </button>
      </IntegrationManager>
    </ul>
  );
});

export default MealSizes;
